export class Compiler {
    CompilerId: number;
    CompilerName: string;
    CompilerDescription: string;
    MonacoEditorName?: string;
}